import makeStoreDev from "./make-store.dev";
import makeStoreProd from "./make-store.prod";

export type AppStore = ReturnType<typeof makeStoreProd>;

const makeStore = (isDev: boolean) => (isDev ? makeStoreDev : makeStoreProd);

export default makeStore;
